import { list } from './classes/request-builder';

export class DropdownLists {
	/*******************
	 * Farm Properties *
	 *******************/
	public sectores = list();

	public parcelas = list();

	public variedades = list();
	/***************************************************************************** */

	/***************
	 * Farm Actors *
	 ***************/
	public clientes = list();
	/***************************************************************************** */

	/******************
	 * Farm Resources *
	 ******************/
	public productos = list();
	/***************************************************************************** */

	/***********************
	 * Farm Categorization *
	 ***********************/
	public propiedad = list(['...', null], ['Propias', 'Propias'], ['Arrendadas', 'Arrendadas']);

	public tipos = list(
		['...', null],
		['Agricultura Ecológica', 'AE'],
		['Producción Integrada', 'PI'],
		['Certificacion Privada', 'CP'],
		['Agrupacion de Tratamiento Integrado en Agricultura', 'Atrias'],
		['Asistida de un asesor', 'AS'],
		['Sin obligacion de aplicar la GIP', 'NO'],
	);
	/***************************************************************************** */

	/******************
	 * Auxiliar Lists *
	 ******************/
	public year = list();
	/***************************************************************************** */
}
